import React from 'react';
import { X, Star, MapPin, Briefcase, Calendar, CheckCircle } from 'lucide-react';

const HandymanProfileModal = ({ isOpen, onClose, handyman }) => {
    if (!isOpen || !handyman) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div className="relative w-full max-w-2xl bg-white dark:bg-slate-800 rounded-2xl shadow-xl overflow-hidden max-h-[90vh] flex flex-col">
                {/* Header */}
                <div className="flex items-center justify-between p-6 border-b border-gray-100 dark:border-slate-700">
                    <h2 className="text-xl font-bold text-gray-900 dark:text-white">Handyman Profile</h2>
                    <button
                        onClick={onClose}
                        className="p-2 text-gray-500 hover:bg-gray-100 dark:hover:bg-slate-700 rounded-lg transition-colors"
                    >
                        <X className="h-5 w-5" />
                    </button>
                </div>

                {/* Content */}
                <div className="overflow-y-auto p-6 space-y-8">
                    {/* Profile Header */}
                    <div className="flex items-start gap-6">
                        <div className="relative">
                            {handyman.avatar ? (
                                <img
                                    src={handyman.avatar}
                                    alt={handyman.name}
                                    className="h-24 w-24 rounded-full object-cover ring-4 ring-gray-50 dark:ring-slate-700"
                                />
                            ) : (
                                <div className="h-24 w-24 rounded-full bg-gradient-to-br from-[#EFA938] to-orange-400 flex items-center justify-center text-white text-3xl font-bold ring-4 ring-gray-50 dark:ring-slate-700">
                                    {handyman.name ? handyman.name.charAt(0).toUpperCase() : 'H'}
                                </div>
                            )}
                            <div className="absolute -bottom-1 -right-1 bg-green-500 h-6 w-6 rounded-full border-4 border-white dark:border-slate-800"></div>
                        </div>

                        <div className="flex-1 pt-2">
                            <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">{handyman.name}</h3>
                            <div className="flex flex-wrap items-center gap-4 text-sm">
                                <div className="flex items-center gap-1.5 px-3 py-1 rounded-full bg-yellow-50 text-yellow-700 border border-yellow-200">
                                    <Star className="h-4 w-4 fill-yellow-400 text-yellow-400" />
                                    <span className="font-semibold">{handyman.rating || "New"}</span>
                                </div>
                                <div className="flex items-center gap-1.5 text-gray-600 dark:text-gray-400">
                                    <Briefcase className="h-4 w-4" />
                                    <span>{handyman.completedJobs || 0} jobs completed</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Stats Grid */}
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                        <div className="p-4 rounded-xl bg-gray-50 dark:bg-slate-700/50 border border-gray-100 dark:border-slate-700 text-center">
                            <p className="text-sm text-gray-500 dark:text-gray-400 mb-1">Success Rate</p>
                            <p className="text-lg font-bold text-gray-900 dark:text-white">98%</p>
                        </div>
                        <div className="p-4 rounded-xl bg-gray-50 dark:bg-slate-700/50 border border-gray-100 dark:border-slate-700 text-center">
                            <p className="text-sm text-gray-500 dark:text-gray-400 mb-1">On Time</p>
                            <p className="text-lg font-bold text-gray-900 dark:text-white">95%</p>
                        </div>
                        <div className="p-4 rounded-xl bg-gray-50 dark:bg-slate-700/50 border border-gray-100 dark:border-slate-700 text-center">
                            <p className="text-sm text-gray-500 dark:text-gray-400 mb-1">Experience</p>
                            <p className="text-lg font-bold text-gray-900 dark:text-white">4+ Yrs</p>
                        </div>
                        <div className="p-4 rounded-xl bg-gray-50 dark:bg-slate-700/50 border border-gray-100 dark:border-slate-700 text-center">
                            <p className="text-sm text-gray-500 dark:text-gray-400 mb-1">Verified</p>
                            <div className="flex items-center justify-center gap-1 text-green-600">
                                <CheckCircle className="h-5 w-5" />
                            </div>
                        </div>
                    </div>

                    {/* About / Skills (Placeholder if data missing) */}
                    <div>
                        <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-3">Expertise</h4>
                        <div className="flex flex-wrap gap-2">
                            {(handyman.skills || ["Plumbing", "Electrical", "General Repair"]).map((skill, index) => (
                                <span key={index} className="px-3 py-1.5 rounded-lg bg-gray-100 dark:bg-slate-700 text-gray-700 dark:text-gray-300 text-sm font-medium">
                                    {skill}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="p-6 border-t border-gray-100 dark:border-slate-700 bg-gray-50 dark:bg-slate-900">
                    <button
                        onClick={onClose}
                        className="w-full py-3 rounded-xl bg-[#EFA938] text-white font-semibold hover:bg-[#d78c1f] transition-colors"
                    >
                        Close Profile
                    </button>
                </div>
            </div>
        </div>
    );
};

export default HandymanProfileModal;
